import React, { useEffect, useState, useRef } from "react";
import Modal from "./Modal";
import PostCard from "../profile/PostCard";
import EditPost from "../profile/EditPost";
import styles from "../../styles/components/common/PostDetailsModal.module.css";

const PostDetailsModal = ({
  post,
  isOpen,
  onClose,
  onPostUpdated,
  onPostDeleted,
  onVoteUpdate,
  onLikeUpdate,
  onSaveUpdate,
  onCommentUpdate,
  scrollToComments = false,
  activeDecision = null,
  shopperCategoryKeys = null,
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const commentsRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setShowEditModal(false);
    }
  }, [isOpen, post?._id]);

  useEffect(() => {
    if (isOpen && scrollToComments && commentsRef.current) {
      // Small delay to ensure the modal content is rendered
      setTimeout(() => {
        commentsRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
  }, [isOpen, scrollToComments]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={styles.postDetailsModal}
      ariaLabel={showEditModal ? "Edit post" : "Post details"}
    >
      {showEditModal ? (
        <EditPost
          post={post}
          onPostUpdated={(updatedPost) => {
            setShowEditModal(false);
            if (onPostUpdated) {
              onPostUpdated(updatedPost);
            }
          }}
          onCancel={() => setShowEditModal(false)}
        />
      ) : (
        <PostCard
          post={post}
          activeDecision={activeDecision}
          shopperCategoryKeys={shopperCategoryKeys}
          onDelete={onPostDeleted}
          onPostUpdated={onPostUpdated}
          onVoteUpdate={onVoteUpdate}
          onLikeUpdate={onLikeUpdate}
          onSaveUpdate={onSaveUpdate}
          onCommentUpdate={onCommentUpdate}
          isGridView={false}
          defaultShowComments
          disableCardClick={true}
          className={styles.modalPostCard}
          onEdit={() => setShowEditModal(true)}
          commentsRef={commentsRef}
        />
      )}
    </Modal>
  );
};

export default React.memo(PostDetailsModal);
